import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { MDXRemoteSerializeResult } from "next-mdx-remote";

export interface StrapiMarkdownSectionDTO
  extends StrapiDynamicZoneComponentDTO {
  content: string;
}

export class MarkdownSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  content: MDXRemoteSerializeResult;
}
